import { writeToClipboard } from "./writeToClipboard";

/**
 * Generates a story outline from the provided story object.
 * @param {*} story - The story object containing the script and metadata.
 *
 * @returns {Object} - An object containing the rich and plain text representations of the outline.
 */
const getOutline = (story) => {
  const fragment = document.createDocumentFragment();

  const title = document.createElement("h1");
  title.textContent = story.title;
  fragment.append(title);

  const outline = `${story.title}\n`;
  const express = {
    title: story.title,
    sections: [],
  };

  story.script.forEach(
    ({
      title,
      text,
      personas,
      solutions,
      comments,
      visual,
      visualMessaging,
    }) => {
      const sectionTitle = document.createElement("h2");
      sectionTitle.textContent = title;

      const ul = document.createElement("ul");
      const section = { title, topics: [{ content: text }] };

      outline += `\n${title}\n`;
      if (text) {
        text.split("\n").forEach((line) => {
          const li = document.createElement("li");
          li.textContent = line;
          ul.appendChild(li);
          outline += `•	${line}\n`;
        });
      }

      //   if (personas && personas.length) {
      //     const personasLine = document.createElement("li");
      //     personasLine.textContent = `[[Personas: ${personas.join(", ")}]]`;
      //     ul.appendChild(personasLine);
      //     outline += `•	${personasLine.textContent}\n`;
      //   }

      //   if (solutions && solutions.length) {
      //     const solutionsLine = document.createElement("li");
      //     solutionsLine.textContent = `[[Solutions: ${solutions.join(", ")}]]`;
      //     ul.appendChild(solutionsLine);
      //     outline += `•	${solutionsLine.textContent}\n`;
      //   }

      // if (visual || visualMessaging) {
      //   const visualLine = document.createElement("li");
      //   visualLine.textContent = `[[Visual: ${visual || visualMessaging}]]`;
      //   ul.appendChild(visualLine);
      //   outline += `•	${visualLine.textContent}\n`;
      // }

      //   if (comments && comments.length) {
      //     const commentsLine = document.createElement("li");
      //     commentsLine.textContent = `[[Comments: ${comments}]]`;
      //     ul.appendChild(commentsLine);
      //     outline += `•	${commentsLine.textContent}\n`;
      //   }

      fragment.append(sectionTitle, ul);
      express.sections.push(section);
    },
  );

  const fragmentContainer = document.createElement("div");
  fragmentContainer.appendChild(fragment);

  return {
    rich: fragmentContainer.innerHTML,
    plain: outline,
    express,
  };
};

const copyStoryOutline = (story) =>
  new Promise((resolve, reject) => {
    try {
      const outline = getOutline(story);
      writeToClipboard(outline)
        .then(() => {
          resolve(outline);
        })
        .catch((error) => {
          console.error("Failed to copy outline to clipboard:", error);
          reject(error);
        });
    } catch (error) {
      console.error("Error generating story outline:", error);
      reject(error);
    }
  });

export { copyStoryOutline };
